/**
 * defa.models.Usage
 * The DEFA Usage model for invoicing.
 * @version 1.2.1
 */
import { defa } from 'defa-object';
import Model    from 'scripts/poppet/model';

const apiHost = defa.vars.apiHost;
const api     = {
	usages: apiHost + '/usages',
};

const Usage = Model.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	urlRoot: api.usages,
	
	defaults: {
		type        : '',
		invoice     : null,
		note        : '',   // manual string to overwrite description
		vat         : null,
		country     : null, // country id, get country from defa.vars
		subscription: null,
		
		transientCounterInvoice: null, // for saving new counter invoices
		transientNumber        : null, // number of items
		transientPrice         : '',   // price per item
		transientAmount        : '',   // sum all items without vat
		transientTotal         : '',   // sum all items with vat
		transientVAT           : '',   // sum of vat
		transientDescription   : '',   // generated string for description
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	// - data handling
	
	/**
	 * Get's either the manual or the generated description, respectively
	 * @return {string}  This usage's description.
	 */
	getDescription: function () {
		return this.get( 'note' ) || this.get( 'transientDescription' );
	},
	
} );

export default Usage;